import React from 'react';
import PropTypes from 'prop-types';

export default function ClientBookingNote({ note }) {
  if (typeof note !== 'string' || !note.trim()) return null;
  return <div className="mt-3 mb-3"><strong>Client booking note</strong><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{note}</p></div>;
}

ClientBookingNote.propTypes = { note: PropTypes.string };
